<template>
    <div class="game-base-info">
        <baseInfoWrap :useBorder="false" titleColor="#d3d5da" textColor="#e9eaed" title="JI CHU XIN XI">
            <table class="base-info-table">
                <tr>
                    <td class="cell-title">
                        <div class="title-wrap">
                            <p>職業</p>
                        </div>
                    </td>
                    <td class="cell-content">
                        <div class="content-wrap">
                            <p>{{ baseData.occupation }}</p>
                        </div>
                    </td>
                    <td class="cell-title">
                        <div class="title-wrap">
                            <p>品質</p>
                        </div>
                    </td>
                    <td class="cell-content">
                        <div class="content-wrap">
                            <p>{{ baseData.quality }}</p>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="cell-title">
                        <div class="title-wrap">
                            <p>駕駛許可</p>
                        </div>
                    </td>
                    <td class="cell-content">
                        <div class="content-wrap">
                            <p>{{ baseData.driveAllow }}</p>
                        </div>
                    </td>
                    <td class="cell-title">
                        <div class="title-wrap">
                            <p>駕駛等級</p>
                        </div>
                    </td>
                    <td class="cell-content">
                        <div class="content-wrap">
                            <p>{{ baseData.driveLevel }}</p>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="cell-title" colspan="2">
                        <div class="title-wrap">
                            <p>陣營</p>
                        </div>
                    </td>
                    <td class="cell-content" colspan="2">
                        <div class="content-wrap">
                            <p>{{ baseData.camp }}</p>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="cell-title">
                        <div class="title-wrap">
                            <p>格鬥</p>
                        </div>
                    </td>
                    <td class="cell-content">
                        <div class="content-wrap">
                            <p>{{ baseData.combat }}</p>
                        </div>
                    </td>
                    <td class="cell-title">
                        <div class="title-wrap">
                            <p>突擊</p>
                        </div>
                    </td>
                    <td class="cell-content">
                        <div class="content-wrap">
                            <p>{{ baseData.assault }}</p>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="cell-title">
                        <div class="title-wrap">
                            <p>射擊</p>
                        </div>
                    </td>
                    <td class="cell-content">
                        <div class="content-wrap">
                            <p>{{ baseData.shooting }}</p>
                        </div>
                    </td>
                    <td class="cell-title">
                        <div class="title-wrap">
                            <p>戰術</p>
                        </div>
                    </td>
                    <td class="cell-content">
                        <div class="content-wrap">
                            <p>{{ baseData.tactics }}</p>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="cell-title">
                        <div class="title-wrap">
                            <p>防禦</p>
                        </div>
                    </td>
                    <td class="cell-content">
                        <div class="content-wrap">
                            <p>{{ baseData.defense }}</p>
                        </div>
                    </td>
                    <td class="cell-title">
                        <div class="title-wrap">
                            <p>工程</p>
                        </div>
                    </td>
                    <td class="cell-content">
                        <div class="content-wrap">
                            <p>{{ baseData.engineering }}</p>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="cell-title" colspan="2">
                        <div class="title-wrap">
                            <p>技力初始值</p>
                        </div>
                    </td>
                    <td class="cell-content" colspan="2">
                        <div class="content-wrap">
                            <p>{{ baseData.apInit }}</p>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="cell-title" colspan="2">
                        <div class="title-wrap">
                            <p>技力最大值</p>
                        </div>
                    </td>
                    <td class="cell-content" colspan="2">
                        <div class="content-wrap">
                            <p>{{ baseData.apMax }}</p>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="cell-title" colspan="2">
                        <div class="title-wrap">
                            <p>技力回復值</p>
                        </div>
                    </td>
                    <td class="cell-content" colspan="2">
                        <div class="content-wrap">
                            <p>{{ baseData.apRecover }}</p>
                        </div>
                    </td>
                </tr>
            </table>
        </baseInfoWrap>
    </div>
</template>

<script>
import baseInfoWrap from './base/baseInfoWrap.vue';
export default {
    components: { baseInfoWrap },
    props: {
        originData: {
            type: Object,
            default: () => { }
        },
        isFullLevel:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            fixedGridData: [
                { index: 1, content: '職業' },
                { index: 3, content: '品質' },
                { index: 5, content: '駕駛許可' },
                { index: 7, content: '駕駛等級' },
                { index: 9, content: '陣營' },
                { index: 11, content: '格鬥' },
                { index: 13, content: '突擊' },
                { index: 15, content: '射擊' },
                { index: 17, content: '戰術' },
                { index: 19, content: '防禦' },
                { index: 21, content: '工程' },
                { index: 23, content: '技力初始值' },
                { index: 25, content: '技力最大值' },
                { index: 27, content: '技力回復值' }
            ]
        }
    },
    methods: {
        getBackgroundColor(index) {
            let greenCell = [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25, 27]
            if (greenCell.includes(index)) {
                return '#f2f2f4'
            } else {
                return 'white'
            }
        },
        getColor(index) {
            let greenCell = [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25, 27]
            if (greenCell.includes(index)) {
                return 'black'
            } else {
                return '#404040'
            }
        },
    },
    computed: {
        baseData() {
            let data = this.originData && this.originData.baseData ? this.originData.baseData : {origin: {},full:{}}
            if(data.origin && data.full){
                return this.isFullLevel ? data.full : data.origin
            }else{
                return {}
            }
        },
    }
}
</script>

<style scoped lang="scss">
.game-base-info {
    height: 100%;

    .base-info-table {
        border-collapse: collapse;
        border-spacing: 0;
        table-layout: fixed;
        width: 100%;

        .cell-title,.cell-content{
            height: .4rem;
            border-color: #d2d5da;
                    border-style: solid;
                    border-width: 1px;
        }

        .cell-title {
            background-color: #f2f2f4;

            .title-wrap {
                display: flex;
                align-items: center;
                justify-content: center;

                p {
                    font-size: .24rem;
                    font-weight: bold;
                }
            }

        }

        .cell-content {
            background-color: white;

            .content-wrap {
                display: flex;
                align-items: center;
                justify-content: center;

                p {
                    font-size: .24rem;
                    color: #404040;
                }
            }

        }

        .base-info-cell {
            height: 100%;
            font-size: .24rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}</style>